export default () => {
  if (document.querySelector(".is-page-editor")) {
    return;
  }

  document.querySelectorAll(".js-simple-homepage-hero").forEach((el) => {
    window.setTimeout(() => {
      const container = el.querySelector(".js-simple-homepage-hero-container");
      const overlay = el.querySelector(".js-simple-homepage-hero-overlay");

      overlay.style.height = container.offsetHeight + "px";

      overlay.classList.add("start-animation");
    }, 500);
  });
};
